/**
 * Shared UI component for UI Filter Bar.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { normalizeDrawerLabel } from '@shared/utils';
import { UiFilterOption } from './ui-filter-bar.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-filter-bar',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-filter-bar.component.html',
  styleUrl: './ui-filter-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFilterBarComponent {
  readonly filters = input<UiFilterOption[]>([]);
  readonly selected = input('');
  readonly changed = output<string>();
  readonly normalizeLabel = normalizeDrawerLabel;

  select(value: string, disabled?: boolean): void {
    if (disabled) {
      return;
    }

    this.changed.emit(value);
  }
}
